module.exports = __webpack_public_path__ + "media/images/team/dandolph-tan-017a86379f02b43715617c85c69b738d.png";